import React from "react";
import { Link } from "react-router-dom";

const HeroPromo: React.FC = () => {
    const categoryData: CategoryItem[] = [
        { imageUrl: 'https://www.datocms-assets.com/34299/1729892481-best-sellers-thumb.png?ixlib=js-3.8.0&w=80&h=80&auto=format&dpr=2&q=50', label: 'Best Sellers' },
        { imageUrl: 'https://www.datocms-assets.com/34299/1729892384-special-offers-thumb.png?ixlib=js-3.8.0&w=80&h=80&auto=format&dpr=2&q=50', label: 'Deals' },
        { imageUrl: 'https://www.datocms-assets.com/34299/1738086831-5080-ww-01-22-25-hero-black-badge-1.png?ixlib=js-3.8.0&w=80&h=80&auto=format&dpr=2&q=50', label: 'Gaming PCs' },
        { imageUrl: 'https://www.datocms-assets.com/34299/1729892515-sub-pcs-thumb.png?ixlib=js-3.8.0&w=80&h=80&auto=format&dpr=2&q=50', label: 'Subscriptions' },
        { imageUrl: 'https://www.datocms-assets.com/34299/1729892548-prebuilt-pcs.png?ixlib=js-3.8.0&w=80&h=80&auto=format&dpr=2&q=50', label: 'Prebuilt PCs' },
        { imageUrl: 'https://www.datocms-assets.com/34299/1729894258-refurbished_pcs.png?ixlib=js-3.8.0&w=80&h=80&auto=format&dpr=2&q=50', label: 'Refurbished PCs' },
    ];

    return (
        <div className="relative w-[90%] m-auto h-[110px] overflow-hidden overflow-x-scroll promo-wrapper">
            <div className="container mx-auto relative w-[fit-content] h-full overflow-hidden">
                <Categories categories={categoryData} />
            </div>
        </div>
    );
};

export default HeroPromo;

interface CategoryItem {
    imageUrl: string;
    label: string;
}
  
interface CategoriesProps {
    categories: CategoryItem[];
}
  
const Categories: React.FC<CategoriesProps> = ({ categories }) => {
    return (
    <div className="promo-items flex cursor-pointer items-center justify-center h-full">
        {categories.map((category, index) => (
        <Link to='/shop'>
            <div className="promo-item" key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 10px', minWidth: '150px', width: '150px' }}>
                <img src={category.imageUrl} alt={category.label} style={{ height: '60px', objectFit: 'contain' }} />
                <span className="text-sm" style={{ marginTop: '5px', textWrap: 'nowrap' }}>{category.label}</span>
            </div>
        </Link>
        ))}
    </div>
    );
};